import styled from "styled-components";

export const IsolatedDom = styled.iframe`
    display: none;
`;

export default IsolatedDom;
